export const resourceNames = {
  CART: 'CART',
  ORDER: 'ORDER',
  USER: 'USER',
  WISHLIST: 'WISHLIST',
};

export const unsubscriptionTypes = {
  FRIENDS: 'FRIENDS',
  LITTLE_FRIENDS: 'LITTLE_FRIENDS',
};

export const addToEventQueue = (event: string, data?: Record<string, any>) => {
  if (import.meta.client) {
    if (!window.auroraQueue) {
      window.auroraQueue = [];
    }

    // if auroraQueue length is 1 and the incoming object has the same event with data, dont push it again
    // page:loading:end initially gets called twice, so we need to prevent duplicates
    if (
      window.auroraQueue.length === 1 &&
      window.auroraQueue[0].event === event &&
      JSON.stringify(window.auroraQueue[0].data) === JSON.stringify(data)
    ) {
      return;
    }

    window.auroraQueue?.push({
      event,
      ...(data !== undefined && { data: deepClone(data) }),
    });
  }
};

/**
 * Checks whether `auroraQueue` already contains an entry with the same `pathName` and event type.
 * Because of timing issue with `15.datalayer.middleware`, identical entries can be added twice.
 * This method prevents duplicates by checking if the latest matching event is already in the queue.
 */
export const canAddEventToQueue = (eventType: string, incomingEventPathName?: string) => {
  if (!import.meta.client || !incomingEventPathName) {
    return;
  }

  const lastEvent = Array.isArray(window.auroraQueue) && window.auroraQueue.at(-1);
  const isSameEventType = lastEvent?.event === eventType;
  const isSameEventPathName = lastEvent?.data?.location?.pathname === incomingEventPathName;

  return !(isSameEventType && isSameEventPathName);
};
